import { useState } from 'react'

// custom components
import AccordionBase from '../../../2compounds/AccordionBase'

const ServiceListAdmin = ({ updateCardLabel, index, data, key, layoutDefaultData }) => {
  const [isOpen, setIsOpen] = useState(true)
  const { label } = data
  return (
    <AccordionBase
      key={key} label={label} data={data} layoutDefaultData={layoutDefaultData} updateCardLabel={(newValue) => updateCardLabel(index, newValue)}
      index={index} isOpen={isOpen} setIsOpen={setIsOpen} admin hideShowHIdeButton hideDragButton
    />
  )
}

export default ServiceListAdmin
